export const marketUrl = process.env['NEXT_PUBLIC_MARKET_API_URL'];
export const adminUrl = process.env['NEXT_PUBLIC_ADMIN_API_URL'];
export const baseAccountsUrl = process.env['NEXT_PUBLIC_ACCOUNTS_API_URL'];
export const redirectMarketUrl =
  process.env['NEXT_PUBLIC_MARKET_REDIRECT_URL'] || 'https://market.bandapixels.com';
export const redirectUrlCreate = `${baseAccountsUrl}/?redirectUrl=${redirectMarketUrl}?create`;
export const redirectAdminUrl = `${baseAccountsUrl}/?redirectUrl=${redirectMarketUrl}`;
export const gameUrl = process.env['NEXT_PUBLIC_GAME_API_URL'];

export const sizeEndpoints = {
  size: '/sizes',
  getSizeById: (id: number): string => `/sizes/${id}`,
};

export const colorEndpoints = {
  color: '/colors',
  getColorById: (id: number): string => `/colors/${id}`,
};

export const productEndpoints = {
  product: '/products',
  getProductById: (id: number): string => `/products/${id}`,
  getArchivedProducts: '/products/archived',
  getArchivedProductById: (id: number): string => `/products/archived/${id}`,
};

export const variantEndpoints = {
  variant: '/variants',
  getVariantById: (id: number): string => `/variants/${id}`,
};

export const imageEndpoints = {
  image: '/images',
  postImage: '/images/upload',
  postImages: '/images/uploads',
  getImageById: (id: string): string => `/images/${id}`,
  previewImage: (id: string): string => `/images/preview/${id}`,
};

export const cartProductEndpoints = {
  cartProduct: '/cart-product',
  cartProductId: (id: number): string => `/cart-product/${id}`,
  restoreCartProduct: (id: number): string => `/cart-product/restore/${id}`,
};

export const ordersEndpoints = {
  orders: '/orders',
  ordersNew: '/orders/new/list',
  ordersId: (id: number): string => `/orders/${id}`,
  getAllOrdersById: (id: number): string => `/orders/${id}/all`,
};

export const purchasesEndpoints = {
  purchases: '/purchases',
  purchasesId: (id: number): string => `/purchases/${id}`,
};

export const userEndpoints = {
  me: 'users/me',
  user: '/users',
  logout: '/logout',
  getUserById: (id: number): string => `/users/get-user/${id}`,
  getUserBalanceById: (id: number): string => `/users/balance/${id}`,
  getUserLogin: () => '/users/login-old',
  updateUserById: (id: number): string => `/users/${id}`,
  updateUserByIdByAdmin: (id: number): string => `/users/admin/${id}`,
  firedUsers: '/users/fired',
  fireUserById: (id: number): string => `/users/fire/${id}`,
  deleteUserById: (id: number): string => `/users/delete/${id}`,
  deletedUsers: '/users/deleted',
};

export const activitiesEndpoints = {
  activities: '/activity',
  activitiesByCategoryId: '/activity/category',
  getActivityById: (id: number): string => `/activity/${id}`,
  getActivityStatusById: (id: number): string => `/activity/${id}/isActive`,
  sortedActivities: '/activity/sorted-category',
};

export const achievementsEndpoints = {
  achievementsAvailable: `/achievements`,
};

export const userActivitiesEndpoints = {
  userActivities: '/user-activity',
  allUsersActivities: '/user-activity/all',
  getAllUsersActivity: '/user-activity/status/many',
  getUserActivityById: (id: number): string => `/user-activity/${id}`,
  getUserActivitiesById: (id: number, sortBy: string): string =>
    `/user-activity/activities/${id}${sortBy}`,
  getUserActivityStatusById: (id: number): string => `/user-activity/${id}/status`,
  pendingUsersActivities: '/user-activity/pending',
};

export const giftsEndpoings = {
  giftsId: (id: number): string => `/gifts/${id}`,
};

export const statisticsEndpoints = {
  StatistictsId: (id: number): string => `/statistics/${id}`,
};

export const wishlishEndpoints = {
  wishlishProduct: '/wishlist-product',
  wishlishProductId: (id: number): string => `/wishlist-product/${id}`,
};

export const userCompetitionEndpoints = {
  userCompetition: '/user-competition',
  getUserCompetitionById: (id: number, order?: string): string => `/user-competition/${id}${order}`,
  deleteUpdateUserCompetitionById: (id: number): string => `/user-competition/${id}`,
  updateUserCompetitionStepById: (id: number): string => `/user-competition/${id}/step`,
  updateUserCompetitionResultById: (id: number): string => `/user-competition/${id}/result`,
};

export const competitionEndpoints = {
  competition: '/competition',
  getCompetitionById: (id: number): string => `/competition/${id}`,
  updateCompetitionStepById: (id: number): string => `/competition/${id}/type`,
};

export const avatarEndpoints = {
  avatar: '/user-avatar',
  getAvatarById: (id: number): string => `/user-avatar/${id}`,
  postAvatar: '/user-avatar/upload',
  allAvatars: '/user-avatar',
};
//todo /activity-category add locale
export const activityCategoriesEndpoints = {
  activityCategoryGet: () => `/activity-category`,
  activityCategory: '/activity-category',
  getActivityCategoryById: (id: number): string => `/activity-category/${id}`,
};

export const sizeTablesEndpoints = {
  sizeTables: '/size-tables',
  getSizeTableById: (id: string): string => `/size-tables/${id}`,
};

export const notificationsEndpoints = {
  updateNotification: (id: number): string => `/notifications/${id}`,
};

export const gameProfileEndpoints = {
  gameProfileId: (id: number): string => `/game-profile/${id}`,
  topPlayers: '/game-profile/top-players',
};

export const seasonsEndpoints = {
  seasons: '/seasons',
};

export const userYearSeasonEndpoints = {
  userYearSeason: '/user-year-season',
};

export const userLevelEndpoints = {
  getUserLevelInfoById: (id: number): string => `/user-level/info/${id}`,
};

export const candidatesEndpoints = {
  candidates: '/candidates',
  getCandidatesById: (id: number): string => `/candidates/get-candidate/${id}`,
  changeCandidate: (id: number): string => `/candidates/${id}`,
};

export const skillsEndpoints = {
  searchSkills: '/skills/search',
  skills: '/skills',
};

export const vacanciesEndpoints = {
  vacancies: '/vacancies',
  getVacancyById: (id: number): string => `/vacancies/${id}`,
  updateVacancy: (id: number): string => `/vacancies/${id}`,
  deleteVacancy: (id: number): string => `/vacancies/${id}`,
};

export const candidateAvatarEndpoints = {
  getAvatarById: (id: number): string => `/candidate-avatar/${id}`,
  postAvatar: '/candidate-avatar/upload',
};

export const candidateDocumentsEndpoints = {
  deleteDoc: (id: number): string => `/candidate-documents/${id}`,
  uploadSingleDoc: '/candidate-documents/upload',
  uploadMultipleDocs: (candidateInfoId: number): string =>
    `/candidate-documents/multi-upload/${candidateInfoId}`,
  getDocuments: (id: number): string => `/candidate-documents/download/${id}`,
};

export const candidateCommentsEndpoints = {
  getComments: (candidateId: number): string => `/candidate-comments/${candidateId}`,
  createComment: '/candidate-comments',
  updateDeleteComment: (id: number): string => `/candidate-comments/${id}`,
};

export const candidateRemindersEndpoints = {
  getComments: (candidateId: number): string => `/candidate-reminders/${candidateId}`,
  createComment: '/candidate-reminders',
  updateDeleteComment: (id: number): string => `/candidate-reminders/${id}`,
};

export const candidateHistoryEndpoints = {
  getHistory: (candidateId: number): string => `/candidate-history/${candidateId}`,
};

export const actionNamesEndpoints = {
  actionNames: '/action-names',
  getAllActionNamesByVacancyId: (id: number): string => `/action-names/vacancy/${id}`,
  getActionNameById: (id: number): string => `/action-names/${id}`,
  updateActionName: (id: number): string => `/action-names/${id}`,
  deleteActionName: (id: number): string => `/action-names/${id}`,
};

export const userPixelsHistoryEndpoints = {
  getUserHistoryById: (id: number): string => `/user-pixels-history/${id}/all`,
};

export const preferencesEndpoints = {
  preferences: '/user-preference',
  getPreferencesByUserId: (userId: number): string => `/user-preference/${userId}`,
};

export const recipientEndpoints = {
  recipient: '/recipient',
  getRecipientByUserId: (userId: number): string => `/recipient/${userId}`,
  getRecipientById: (id: number): string => `/recipient/${id}`,
};

export const secretSantaEndpoints = {
  getAllRecipients: '/recipient',
  getAllRecipientsWithoutReceiver: '/recipient/without-receiver',
  getRecipient: (id: number): string => `/recipient/${id}`,
  getReceiver: (id: number): string => `/recipient/receiver/${id}`,
  createRecipient: '/recipient',
  updateRecipient: (id: number): string => `/recipient/${id}`,
  upsertRecipientWithPreferences: '/recipient/with-preferences',
};
